import * as React from "react";
import PropTypes from "prop-types";
import capitalize from "lodash-es/capitalize";
import isEmpty from "lodash-es/isEmpty";

import Divider from "ui/Divider";
import Button from "ui/Button";
import Typography from "ui/Typography";

import useIAM from "hooks/useIAM";

import { OKTA } from "constants/iamTypes";

import OktaIcon from "assets/svg/okta.svg";
import KeyIcon from "assets/svg/key2.svg";

const IAM = ({ iamTypes, remoteIamEnabled }) => {
  const { loginWithIamIfQueryWithAuth, loginLoading } = useIAM();

  React.useEffect(() => {
    loginWithIamIfQueryWithAuth();
  }, []);

  if (!remoteIamEnabled) return null;

  const getIamIcon = (iam) => {
    switch (iam) {
      case OKTA:
        return <OktaIcon width="20px" />;
      default:
        return <KeyIcon width="20px" />;
    }
  };

  const handleClick = (link) => {
    if (isEmpty(link)) return;
    window.location.href = link;
  };

  const buttons = iamTypes.map((item) => {
    return (
      <Button
        key={`iam-auth-${item.authType}`}
        id={`iam-auth-${item.authType}-button`}
        variant="outlined"
        className="iam-login-button"
        startIcon={getIamIcon(item.authType)}
        onClick={() => handleClick(item.link)}
        loading={loginLoading}
        loadingPosition="start"
      >{`Login with ${capitalize(item.authType)}`}</Button>
    );
  });

  return (
    <div className="iam-fields">
      <Divider>
        <Typography variant="subtitle1" color="surface.onSurfaceVariant">
          Or continue with:
        </Typography>
      </Divider>
      {buttons}
    </div>
  );
};

IAM.propTypes = {
  iamTypes: PropTypes.arrayOf(
    PropTypes.shape({ authType: PropTypes.string.isRequired }),
  ),
  remoteIamEnabled: PropTypes.bool,
};

// eslint-disable-next-line react-refresh/only-export-components
export default IAM;
